module.exports = __webpack_public_path__ + "static/media/atm.ace6eb68.svg";